import { getEmptyStateMessage } from '@/shared/copy/emptyStates';
import { gridPaths } from '@/shared/hooks';
import { createFeatureGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchTestsGrid } from './gridQuery';
import type { TestInclude } from '../data/tests';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { TestListItemDto } from '@flowqa/shared';

export const testsGridConfig = ({
  projectId,
  organisationId,
  include,
  fixedFilters,
  initialSortModel,
  initialFilterModel,
  persistKey,
  includeDeltas = true,
  syncStateToUrl = false,
}: {
  projectId?: string | null;
  organisationId?: string | null;
  include?: TestInclude;
  fixedFilters?: GridQueryInput['filters'];
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  includeDeltas?: boolean;
  syncStateToUrl?: boolean;
} = {}): GridConfig<TestListItemDto> =>
  createFeatureGridConfig<TestListItemDto>(
    {
      path: gridPaths.tests,
      queryFn: async (input) =>
        await fetchTestsGrid(projectId, organisationId, input, include, includeDeltas),
      noRowsText: getEmptyStateMessage('entity.noneFound', { entity: 'test' }),
      defaultPersistKey: 'tests',
      defaultSortModel: [{ field: 'latestRunTimestamp', sort: 'desc' }],
    },
    { fixedFilters, initialSortModel, initialFilterModel, persistKey, syncStateToUrl },
  );

export type TestsGridConfig = ReturnType<typeof testsGridConfig>;
